<template>
    <main class="page-phototheque">
        <slot name="mantel"></slot>

        <div class="container">
            <slot name="content"></slot>
        </div>
    </main>
</template>

<script>
    export default {
        name: 'Phototheque',
    };
</script>

<style scoped lang="scss">
    .page-phototheque {
    }
</style>
